import { Dispatch } from 'redux';

// types
import { IAuthActionTypes } from 'models/IAuthState';
import { IHistory } from 'models/ICommon';

// services
import authService from 'services/authService';

// configs
import { PATH_NAME } from 'configs';
import { setLoading } from './app.action';

export const login =
  (username: string, password: string, history: IHistory, roleUser?: string) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: IAuthActionTypes.LOGIN_REQUEST });
    dispatch(setLoading(true));
    let { user, role, state, error, passwordUpdated } = await authService.loginWithAuth0(username, password);
    if (error) {
      dispatch({
        type: IAuthActionTypes.LOGIN_FAILURE,
        payload: { user: null, role: null, error: error, state: null },
      });
      dispatch(setLoading(false));
      return;
    }
    //passwordUpdated = false;
    dispatch(setLoading(false));
    if (passwordUpdated || role?.toLowerCase() == 'admin') {
      dispatch({
        type: IAuthActionTypes.LOGIN_SUCCESS,
        payload: { user, role, error: null, state },
      });
      history.push(PATH_NAME.ROOT);
    } else if (role?.toLowerCase() != 'admin') {
      history.push(PATH_NAME.UPDATE_PASSWORD);
    }
  };

export const logout = () => (dispatch: Dispatch<any>) => {
  authService.logOut();
  dispatch({ type: IAuthActionTypes.LOGOUT });
};

export const setUserData = (user: string, role: string, state: string) => (dispatch: Dispatch<any>) => {
  dispatch({
    type: IAuthActionTypes.SILENT_LOGIN,
    payload: { user, role, state },
  });
};
